import { ApplePayButtonType } from '@adyen/adyen-web/dist/types/components/ApplePay/types';
import { PaymentMethodsResponse } from '@adyen/adyen-web/dist/types/core/ProcessResponse/PaymentMethodsResponse/types';
import classNames from 'classnames';

import { APPLE_PAY_CONTAINER_ID } from '@config/consts';
import useAdyenApplePay from '@hooks/useAdyenApplePay';
import { useTranslation } from '@hooks/useTranslations';
import { useAppContext } from '@providers/AppContextProvider';
import { AdyenConfig } from '@types-internal/AdyenTypes';

import styles from './AdyenApplePayButton.module.scss';
import { ApplePayButtonColor } from './AdyenApplePayButton.static';

import '@adyen/adyen-web/dist/adyen.css';

export interface AdyenApplePayButtonProps extends AdyenConfig {
  countryCode: string;
  // The "amount" in minor units
  amount: number;
  paymentMethodsResponse: PaymentMethodsResponse;
  onSubmit: (applePayToken: string) => void;
  onFatalError: (error: unknown) => void;
  buttonColor?: ApplePayButtonColor;
  buttonType?: ApplePayButtonType;
  siteId?: number;
  sid?: string;
  currency: string;
  customerId?: string;
  customerType?: string;
}

const AdyenApplePayButton: React.FC<AdyenApplePayButtonProps> = ({
  adyenEnvironment,
  clientKey,
  countryCode,
  amount,
  paymentMethodsResponse,
  onSubmit,
  onFatalError,
  buttonColor = 'black',
  buttonType = 'buy',
  currency,
  siteId,
  sid,
  customerId,
  customerType,
}) => {
  const { t } = useTranslation();
  const { locale } = useAppContext();

  useAdyenApplePay({
    adyenEnvironment,
    clientKey,
    locale,
    t,
    countryCode,
    currency,
    amount,
    paymentMethodsResponse,
    onSubmit,
    onFatalError,
    buttonColor,
    buttonType,
    siteId,
    sid,
    customerId,
    customerType,
  });
  return (
    <div
      id={APPLE_PAY_CONTAINER_ID}
      className={classNames(styles.applePayContainer, styles.applePayRoundBorder)}
      data-zta="adyen-apple-pay-button"
      data-testid="adyen-apple-pay-button"></div>
  );
};

export default AdyenApplePayButton;
